import { render, staticRenderFns } from "./CoolSuperScreen.vue?vue&type=template&id=779eb5e4&scoped=true&"
import script from "./CoolSuperScreen.vue?vue&type=script&lang=js&"
export * from "./CoolSuperScreen.vue?vue&type=script&lang=js&"
import style0 from "./CoolSuperScreen.vue?vue&type=style&index=0&id=779eb5e4&scoped=true&lang=css&"
import style1 from "./CoolSuperScreen.vue?vue&type=style&index=1&id=779eb5e4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779eb5e4",
  null
  
)

export default component.exports